export const GET_USER = "GET_USER";
export const SET_USER = "SET_USER";
export const AUTH_USER = "AUTH_USER";
export const SET_TOKEN = "SET_TOKEN";
export const SET_AUTHENTICATION = "SET_AUTHENTICATION";

export const LOG_OUT = "LOG_OUT";
